import ICalculatorConfiguration from "../../models/ICalculatorConfiguration";
import { ICalculatorInput } from "../../models/ICalculatorInput";
import { PaperSizes } from "../PaperSizesUtils";

export default function filterPaperSizes(
  calculatorInput: ICalculatorInput,
  pricingConfiguration: ICalculatorConfiguration,
) {
  const printingOption =
    pricingConfiguration.pricingConfiguration.printingOptions.filter(
      (x) => x.code === calculatorInput.selectedPrintingOption,
    )[0];

  const filteredPaperSizes = PaperSizes.filter(
    (ps) =>
      printingOption !== undefined &&
      printingOption.supportedPaperSizes !== undefined &&
      printingOption.supportedPaperSizes.includes(ps.code) &&
      pricingConfiguration.pricingConfiguration.pricingMatrix.filter(
        (pm) =>
          pm.selectedPrintingOption ===
            calculatorInput.selectedPrintingOption &&
          pm.selectedPaperSize === ps.code,
      ).length > 0,
  );

  filteredPaperSizes.sort((a, b) => a.name.localeCompare(b.name));

  return filteredPaperSizes;
}
